/**
 * The status poll after a workload start (docs/WORKLOAD-PROBLEMS-PLAN.md §4.3).
 *
 * Kept apart from the lazily loaded instance page so the route that supplies
 * the poll callback does not pull the page into the main bundle.
 */

/** What the poll callback returns when no provider token is held: stop, never prompt. */
export const POLL_NO_TOKEN = Symbol('poll-no-token')

/** Mutable so tests do not wait in real time. */
export const STATUS_POLL = {
  /** Between reads while a service is starting. */
  intervalMs: 10_000,
  /** Polling stops this long after the start, whatever the state. */
  windowMs: 5 * 60_000,
  /** After this long a host that cannot report problems is shown as Not reporting. */
  overdueMs: 3 * 60_000,
}
